export default "__VITE_ASSET__5_Xi9mQL__"